module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('cc-nav-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shouldShowNavigation),
      expression: "shouldShowNavigation"
    }]
  }), _vm._v(" "), _c('div', {}, [_c('cc-alerts'), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('footer-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shouldShowNavigation),
      expression: "shouldShowNavigation"
    }]
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6908ee0e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Root.vue
// module id = 902
// module chunks = 16